module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lips-balms@2x_b49818.jpg";